import React, { useLayoutEffect } from 'react';
import { useIntl } from 'react-intl';

import { ConfigProvider, Layout } from 'antd';

import { YandexMetrika } from '../../../../components/YandexMetrika';

import { useHomeMessageId } from '../../hooks/useHomeMessageId';
import AiAnalysisSection from './AiAnalysisSection';
import EverywhereSection from './EverywhereSection';
import FinalCta from './FinalCta';
import Footer from './Footer';
import HeaderNav from './HeaderNav';
import Hero from './Hero';
import { HomeAuthModalProvider } from './HomeAuthModalContext';
import IntegrationSection from './IntegrationSection';
import LegacyCards from './LegacyCards';
import PlatformSection from './PlatformSection';
import PrimaryCard from './PrimaryCard';
import SecuritySection from './SecuritySection';
import TrainingSection from './TrainingSection';

const { Content } = Layout;

const HomePage = () => {
  const intl = useIntl();
  const homeMessageId = useHomeMessageId();

  useLayoutEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const { theme: previousTheme } = document.documentElement.dataset;
    document.documentElement.dataset.theme = 'dark';

    return () => {
      if (previousTheme) {
        document.documentElement.dataset.theme = previousTheme;
        return;
      }

      delete document.documentElement.dataset.theme;
    };
  }, []);

  return (
    <ConfigProvider
      theme={{
        hashed: false,
        cssVar: { key: 'app' },
        token: {
          borderRadius: 24,
          colorPrimary: '#0075ff',
          fontFamily:
            "'Stolzl', 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        },
      }}
    >
      <Layout className="home-page">
        <HomeAuthModalProvider>
          <HeaderNav />
          <Content
            className="home-page__main"
            aria-label={intl.formatMessage({
              id: homeMessageId('page.ariaLabel'),
            })}
          >
            <Hero />
            <PrimaryCard />
            <LegacyCards />
            <PlatformSection />
            <TrainingSection />
            <IntegrationSection />
            <AiAnalysisSection />
            <EverywhereSection />
            <SecuritySection />
            <FinalCta />
          </Content>
          <Footer />
        </HomeAuthModalProvider>
      </Layout>

      <YandexMetrika />
    </ConfigProvider>
  );
};

export default HomePage;
